import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';

export class AdhocTransferBasic extends Component {
    static displayName = AdhocTransferBasic.name;

    constructor(props) {
        super(props);
        this.state = {
            inventoriesOnFromLocation: [],
            inventoriesOnToLocation: [],
            inventoriesInTransfer: [],
            sending: false,
            headerTitle: "Adhoc Transfer",
            alertMessage: "",
            toLocation: "",
            fromLocation: "",
            fromLocationBarcode: "",
            toLocationBarcode: "",
            hasFromLocationLoaded: false,
            unitsToTransferOut: 0,
            unitsToTransferIn: 0,
            scannedProductBarcode: "",
            namecode: "",
            createdDocket: 0,
            transferOut: true,
            transferIn: false,
            hasHeldStockOnFromLocation: false,
            hasHeldStockOnToLocation: false,
            resumeTransfer: false,
            transferCreatedBy: "",
            transferUpdatedBy: ""
        };
        this.history = props.history;
    }

    componentDidMount() {
        this.refs.transferFromLocationInput.focus();
        if (this.props.location && this.props.location.state) {

            var selectedState = this.props.location.state;
            this.state.createdDocket = selectedState.createdDocket;
            this.state.namecode = selectedState.namecode;
            this.loadInventoryContentsInTransfer();
            this.loadDocketDetails();
        }
    }
    clearAll(message) {
        this.setState({
            alertMessage: message,
            inventoriesOnFromLocation: [],
            inventoriesOnToLocation: [],
            inventoriesInTransfer: [],
            sending: false,
            fromLocation: "",
            fromLocationBarcode: "",
            toLocation: "",
            toLocationBarcode: "",
            hasFromLocationLoaded: false,
            unitsToTransferOut: 0,
            unitsToTransferIn: 0,
            scannedProductBarcode: "",
            namecode: "",
            createdDocket: 0,
            hasHeldStockOnFromLocation: false,
            hasHeldStockOnToLocation: false,
            transferCreatedBy: "",
            transferUpdatedBy: ""
        });
    }

    async loadFromLocationInventories() {
        if (this.state.fromLocationBarcode == "") {

            this.setState({ alertMessage: "Enter a valid Location barcode to load the Stock from" });
            return;
        }

        this.state.fromLocationBarcode = this.state.fromLocationBarcode.trim();
        var barCodeFormat = this.state.fromLocationBarcode.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {
            this.setState({ alertMessage: "Invalid Transfer From Location Barcode!! Barcode should be of this format : Stage-01-01-09" });
            return;
        }

        //special requirement to prefix barcode segment with 0 if barcode segment length is 1 (1A-1-1-1 will be prefixed like 1A-01-01-01)
        this.state.fromLocationBarcode = barCodeFormat[0] + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[1]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[2]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[3]);

        this.setState({ alertMessage: "" });
        var warehouseID = MyGlobal.warehouse;
        this.state.loading = true;
        fetch(`api/Transfer/GetInventoryLines?barcodeText=${this.state.fromLocationBarcode}&warehouseID=${warehouseID}`)
            .then(async response => {
                

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Cannot load Stock. " + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ inventoriesOnFromLocation: data.inventoriesOnTransferFromLocation, fromLocation: data.locationId, hasFromLocationLoaded: true });
                            if (!this.state.inventoriesOnFromLocation || this.state.inventoriesOnFromLocation.length === 0) {
                                this.setState({ alertMessage: "This location does not contain inventory. Cannot start transfer here", hasFromLocationLoaded: false, fromLocationBarcode:"" });
                            }

                            this.refs.productBarcodeInputOut.focus();
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load inventories!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load inventories!!" });
                    }
                    
                }

            })
            .catch(error => {
                this.setState({ inventoriesOnFromLocation: [], alertMessage: error });
            });
    }

    prefixBarcodeSegmentWithZero(barCodeSegment) {
        if (barCodeSegment.length == 1) {
            barCodeSegment = "0" + barCodeSegment;
        }
        return barCodeSegment;
    }

    async putInventoryOnTransfer(scannedProductBarcode) {

        if (!scannedProductBarcode) {
            this.setState({ alertMessage: "Please scan the Product barcode" });
            return;
        }
        if (!this.state.inventoriesOnFromLocation || this.state.inventoriesOnFromLocation.length <= 0) {
            this.setState({ alertMessage: "There are no inventories loaded" });
            return;
        }
        const inventory = this.state.inventoriesOnFromLocation.find((element) => {
            return element.barcode === scannedProductBarcode;
        });

        if (this.state.fromLocation <= 0) {
            this.setState({ alertMessage: "Please scan the Transfer from Location" });
            return;
        }
        if (!inventory) {
            this.setState({ alertMessage: "Inventory with barcode: " + scannedProductBarcode + " not found in the list of inventories for this location" });
        }
        this.setState({ alertMessage: "", namecode: inventory.namecode });
        this.state.loading = true;
        this.state.unitsToTransferOut = this.state.unitsToTransferOut > 0 ? inventory.packSize * this.state.unitsToTransferOut : inventory.packSize;
        this.state.unitsToTransferIn = this.state.unitsToTransferOut;
        const adhocTransferRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                LocationId: this.state.fromLocation,
                Namecode: inventory.namecode,
                Docket: this.state.createdDocket,
                ProductBarcode: inventory.barcode,
                Units: this.state.unitsToTransferOut,
                StaffName: MyGlobal.staffName
            })
        };
        fetch('api/Transfer/PutInventoryOnTransfer', adhocTransferRequestOptions)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {

                    const errorText = await response.text();
                    this.setState({ alertMessage: "Transfer Failed!! " + errorText });
                }
                else {
                    this.state.createdDocket = data.docket;
                    if (data.success && data.Docket > 0) {
                        this.setState({ alertMessage: "Moved inventory out of Location" });
                        this.loadInventoryContentsInTransfer();
                        this.loadDocketDetails();
                    }
                    else {
                        if (data.docket > 0 && data.responseText === "Failure to create docket line") {
                            this.setState({ alertMessage: "Moved inventory out of Location" });
                            this.loadInventoryContentsInTransfer();
                            this.loadDocketDetails();
                        }
                        else {
                            this.setState({ alertMessage: "Transfer Failed!! " + data.responseText });
                        }
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ inventories: [], alertMessage: error });
            });
    }

    async validateDestiantionLocation() {
        if (this.state.toLocationBarcode == "") {

            this.setState({ alertMessage: "Enter a valid Location barcode to transfer the Stock to" });
            return;
        }

        this.state.toLocationBarcode = this.state.toLocationBarcode.trim();
        var barCodeFormat = this.state.toLocationBarcode.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {
            this.setState({ alertMessage: "Invalid Transfer To Location Barcode!! Barcode should be of this format : Stage-01-01-09" });
            return;
        }

        //special requirement to prefix barcode segment with 0 if barcode segment length is 1 (1A-1-1-1 will be prefixed like 1A-01-01-01)
        this.state.toLocationBarcode = barCodeFormat[0] + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[1]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[2]) + "-" + this.prefixBarcodeSegmentWithZero(barCodeFormat[3]);

        this.setState({ alertMessage: "" });
        var warehouseID = MyGlobal.warehouse;
        this.state.loading = true;
        fetch(`api/Transfer/GetLocationDetails?barcodeText=${this.state.toLocationBarcode}&warehouseID=${warehouseID}`)
            .then(async response => {
            
                // check for error response
                if (!response.ok) {
                    this.state.loading = false;
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to validate Destination Location!!" + errorText });
                    return;
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({toLocation: data.locationId });
                            this.putInventoryInLocation(this.state.scannedProductBarcode, this.state.unitsToTransferIn);
                        }
                        else {
                            this.state.loading = false;
                            this.setState({ alertMessage: "Failed to validate Destination Location!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.state.loading = false;
                        this.setState({ alertMessage: "Failed to validate Destination Location!!" });
                    }


                }

            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
      
    }


    async putInventoryInLocation(scannedProductBarcode, unitsToMove) {

        if (this.state.toLocationBarcode == "" || this.state.toLocation <= 0) {

            this.setState({ alertMessage: "Enter a valid Location barcode to transfer the Stock To" });
            return;
        }
        if (!scannedProductBarcode) {
            this.setState({ alertMessage: "Please scan the Product barcode" });
            return;
        }
        if (unitsToMove <= 0) {
            this.setState({ alertMessage: "Please enter the units to load into the new Location" });
            return;
        }
        if (!this.state.inventoriesInTransfer || this.state.inventoriesInTransfer.length <= 0) {
            this.setState({ alertMessage: "There are no inventories in Transfer" });
            return;
        }
        const inventory = this.state.inventoriesInTransfer.find((element) => {
            return element.barcode === scannedProductBarcode;
        });

        if (!inventory) {
            this.setState({ alertMessage: "Inventory with barcode: " + scannedProductBarcode + " not found in the list of inventories in Transfer List" });
            return;
        }
        this.setState({ alertMessage: "" });
        this.state.loading = true;
        const adhocTransferRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                LocationId: this.state.toLocation,
                Namecode: this.state.namecode,
                Docket: this.state.createdDocket,
                ProductBarcode: inventory.barcode,
                Units: unitsToMove,
                WarehouseId: MyGlobal.warehouse,
                StaffName: MyGlobal.staffName
            })
        };
        fetch('api/Transfer/PutInventoryInLocation', adhocTransferRequestOptions)
            .then(async response => {

                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    this.state.loading = false;
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Transfer Failed!! " + errorText });
                }
                else {
                    
                    if (!data.success) {
                        this.state.loading = false;
                        this.setState({ alertMessage: "Transfer Failed!! " + data.responseText });
                    }
                    else {
                        this.setState({ alertMessage: data.responseText });
                        //Refresh Lists
                        this.loadInventoryContentsInTransfer();
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ inventories: [], alertMessage: error });
            });
    }


    async loadInventoryContentsInTransfer() {

        this.state.loading = true;
        fetch(`api/Transfer/GetInventoryLinesInTransfer?docketNumber=${this.state.createdDocket}&namecode=${this.state.namecode}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {
                    this.state.loading = false;
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Cannot load Inventories in Transfer. " + errorText });
                }
                else {
                    this.setState({ inventoriesInTransfer: data });
                    if (this.state.inventoriesInTransfer && this.state.inventoriesInTransfer.length > 0) {
                        this.setState({ transferOut: false, transferIn: true });
                    }
                    this.autoFinalizaDocket();
                }

            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ inventoriesInTransfer: [], alertMessage: error });
            });

    }

    async loadDocketDetails() {

        if (this.state.createdDocket > 0) {
            this.state.loading = true;
            fetch(`api/Transfer/GetDocketDetails?docketNumber=${this.state.createdDocket}&namecode=${this.state.namecode}`)
                .then(async response => {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const data = isJson ? await response.json() : null;

                    this.state.loading = false;
                    // check for error response
                    if (!response.ok) {
                        const errorText = await response.text();
                        this.setState({ alertMessage: "Failed to load details of user who created/updated the Transfer " + errorText });
                    }
                    else {

                        if (data.notes) {
                            var staffNames = data.notes.split("/");
                            var createdBy = staffNames[0];
                            var updatedBy = staffNames[1]
                            if (createdBy && createdBy.length > 0) {
                                var createdByName = createdBy.split(":")[1];
                                if (createdByName) {
                                    this.setState({ transferCreatedBy: "Transfer Created By : " + createdByName });
                                }
                            }
                            if (updatedBy && updatedBy.length > 0) {
                                var updatedByName = updatedBy.split(":")[1];
                                if (updatedByName) {
                                    this.setState({ transferUpdatedBy: "Transfer Updated By : " + updatedByName });
                                }
                            }
                            
                        }
                    }
                })
                .catch(error => {
                    this.state.loading = false;
                    this.setState({ alertMessage: "Failed to load details of user who created/updated the Transfer " + error });
                });
        }

    }

    async finaliseDocket() {
        if (this.state.createdDocket <= 0) {
            this.state.loading = false;
            this.setState({ alertMessage: "Finalise Docket Failed!! Docket Number cannot be zero" });
            return;
        }
        if (this.state.inventoriesInTransfer.length > 0) {
            this.state.loading = false;
            this.setState({ alertMessage: "Finalise Docket Failed!! Please move items in Transfer to a location and then attempt Finalise Docket" });
            return;
        }
        this.setState({ alertMessage: ""});
        this.state.loading = true;
        const finaliseDocketReqest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Namecode: this.state.namecode,
                DocketId: this.state.createdDocket,
                WarehouseId: MyGlobal.warehouse,
                StaffName: MyGlobal.staffName
            })
        };
        fetch('api/Transfer/FinaliseDocket', finaliseDocketReqest)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Finalise Docket Failed!! " + errorText });
                    return;
                }
                else {

                    if (!data.success) {
                        this.setState({ alertMessage: "Finalise Docket Failed!! " + data.responseText });
                        return;
                    }
                    else {
                        this.clearAll(data.responseText);

                        this.setState({ transferOut: true, transferIn: false });

                        const { location, history } = this.props;
                        //use the state via location.state
                        //and replace the state via
                        history.replace();
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ alertMessage: error });
            });
    }

    autoFinalizaDocket() {
        if (this.state.inventoriesInTransfer.length === 0 && this.state.createdDocket > 0) {

            this.finaliseDocket();
        }
        else {
            this.state.loading = false;
        }

    }

    moveInventoryOut( tableId, scannedBarcode) {
        if (tableId === 'fromLocationTable') {
            this.setState({ scannedProductBarcode: scannedBarcode, unitsToTransferOut: 0, unitsToTransferIn: 0 });
        }
        return;
    }

    renderTable(data, tableId) {
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Barcode</th>
                        <th>Description</th>
                        <th>Units</th>
                        <th>Commited</th>
                        <th>Namecode</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row,index) =>
                        <tr key={index} onClick={() => { this.moveInventoryOut(tableId, row.barcode)  }}>
                            <td>{row.productCode}</td>
                            <td>{row.barcode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.units}</td>
                            <td>{row.committedUnits}</td>
                            <td>{row.namecode}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }


    renderInventoryContentsInTransfer() {
        
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Barcode</th>
                        <th>Description</th>
                        <th>Units</th>
                        <th>Commited</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.inventoriesInTransfer.map((row,index) =>
                        <tr key={index} onClick={() => { this.setState({ scannedProductBarcode: row.barcode, unitsToTransferIn: row.units  })}}>
                            <td>{row.productCode}</td>
                            <td>{row.barcode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.units}</td>
                            <td>{row.committed}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {

        const handleFromLocationKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.loadFromLocationInventories();
            }
        };
        const handleToLocationKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateDestiantionLocation();
            }
        };

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let inventoryContentsFromLocation =  this.renderTable(this.state.inventoriesOnFromLocation, "fromLocationTable");

        let inventoryContentsInTransfer =  this.renderInventoryContentsInTransfer();

        let loadingProgress = this.state.loading ? <Container><Row><Col><p><em>Loading...</em></p> </Col></Row></Container>: <p></p>;

        return (
            <div>
                {loadingProgress}
                <Container>
                    <Row>
                        <Col> {alertMessage}</Col>
                    </Row>
                    <Row>
                        <Col><b> {this.state.transferCreatedBy} </b></Col>
                    </Row>
                    <Row>
                        <Col><b> {this.state.transferUpdatedBy} </b></Col>
                    </Row>
                </Container>
                <Container fluid classsname="transferOutContainer" style={{ display: this.state.transferOut ? 'block' : 'none' }}  >
                    <Row className="mb-3">
                        <Col xs={9}></Col>
                        <Col xs={3} style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                            <button type="button" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} className="btn btn-success col-12 mb-2" onClick={() => { this.clearAll("Please scan again"); }}>Back</button>
                        </Col>
                    </Row>
                    <Row className="mb-1" style={{ display: !this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col xs={12}>
                            <label>Source Location :</label>
                            <input ref="transferFromLocationInput" className="form-control" placeholder="Enter Location Barcode"
                                value={this.state.fromLocationBarcode}
                                onChange={(e) => {
                                    this.setState({ fromLocationBarcode: e.target.value, toLocation: "", inventoriesOnFromLocation: [] });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleFromLocationKeypress} ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3" > <Col></Col></Row>
                    <Row style={{ display: !this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.loadFromLocationInventories();  }}>Next</button>
                            
                        </Col>
                    </Row>
                    <Row className="mb-3" > <Col></Col></Row>
                    <Row className="mb-1" >
                        <Col xs={6} style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                            <label>Select Product :</label>
                            <input ref="productBarcodeInputOut" className="form-control" placeholder="Enter Product Barcode"
                                value={this.state.scannedProductBarcode}
                                onChange={(e) => {
                                    this.setState({ scannedProductBarcode: e.target.value });
                                }}
                                readOnly={this.state.sending}  ></input>
                        </Col>
                        <Col xs={6} style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                            <label>Qty :</label>
                            <input ref="unitInput" className="form-control" placeholder="Enter units"
                                value={this.state.unitsToTransferOut}
                                onChange={(e) => {
                                    this.setState({ unitsToTransferOut: e.target.value });
                                }}
                                readOnly={this.state.sending}  ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3" > <Col></Col></Row>
                    <Row className="mb-3" >
                        <Col xs={6} style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }}>
                            <label className="small">Client : {this.state.namecode}</label>
                        </Col>
                        <Col xs={6} style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }}>
                            <label className="small">Docket : {this.state.createdDocket}</label>
                        </Col>
                    </Row>
                    <Row style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.putInventoryOnTransfer(this.state.scannedProductBarcode); }}>Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col xs={12}>
                            <label className="small">Location : {this.state.fromLocationBarcode}</label>
                        </Col>
                    </Row>
                    <Row className="mb-3" style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col>Inventory</Col>
                    </Row>
                    <Row style={{ display: this.state.hasFromLocationLoaded ? 'block' : 'none' }} >
                        <Col xs={12}>
                            <div className="tableHolder hm-50vh mb-3">
                                {inventoryContentsFromLocation}
                            </div>
                        </Col>
                    </Row>
                </Container>

                <Container fluid classsname="transferInContainer" style={{ display: this.state.transferIn ? 'block' : 'none' }}>
                    <Row className="mb-1">
                        <Col>
                            <label>Destination Location :</label>
                            <input ref="transferToLocationInput" className="form-control" placeholder="Enter Location Barcode"
                                value={this.state.toLocationBarcode}
                                onChange={(e) => {
                                    this.setState({ toLocationBarcode: e.target.value });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleToLocationKeypress} ></input>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.validateDestiantionLocation(); }}>Next</button>

                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <label className="small">Client : {this.state.namecode}</label>
                        </Col>
                        <Col>
                            <label className="small">Docket : {this.state.createdDocket}</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label>Inventories in Transfer :</label>
                            <div className="tableHolder hm-50vh mb-3">
                                {inventoryContentsInTransfer}
                            </div>
                        </Col>
                    </Row>
                   
                </Container>
            </div>
        );
    }
}
